module.exports = __webpack_public_path__ + "img/google-play-badge-nl.175c2abf.png";